<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>

html{
  background:white;
}

@font-face {
  font-family: "Garamond";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  src: local("Garamond"),   url(./fonts/CormorantGaramond-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Garamond";
  font-weight: 400;
  font-style: italic;
  font-display: auto;
  src: local("Garamond"),   url(./fonts/CormorantGaramond-Italic.ttf) format("truetype");
}
@font-face {
  font-family: "Garamond";
  font-weight: 700;
  font-style: normal;
  font-display: auto;
  src: local("Garamond"),   url(./fonts/CormorantGaramond-Bold.ttf) format("truetype");
}
@font-face {
  font-family: "Franklin";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  src: local("Franklin"),   url(./fonts/LibreFranklin-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Franklin";
  font-weight: 800;
  font-style: normal;
  font-display: auto;
  src: local("Franklin"),   url(./fonts/LibreFranklin-ExtraBold.ttf) format("truetype");
}
@font-face {
  font-family: "Franklin";
  font-weight: 200;
  font-style: normal;
  font-display: auto;
  src: local("Franklin"),   url(./fonts/LibreFranklin-Thin.ttf) format("truetype");
}

#app {
  font-family: Garamond;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  background:white;
}
.globe-button{
        background:white;
        border:2px #2c3e50 solid;
        padding:5px;
        color:#2c3e50;
        margin-right:10px;
        font-size:24px
    }
  .globe-button:hover{
        background:rgba(0,0,0,0.2);
    }


</style>
